import  React, { useState } from "react";

import clsx from 'clsx';

import CustomIcon from 'assets/Icon';

import { useClientCommunicationContext } from "context/clientCommunication.context";

import Flex from "modules/shared/components/general/Flex/Flex";
import UserEmailDrawer from "modules/ClientCommunication/components/UserEmailDrawer/UserEmailDrawer";
import OwnerCard from 'modules/ClientCommunication/components/OwnerCard';

import { useStylesEmailBlock } from "modules/ClientCommunication/components/EmailBlock/EmailBlock.styles";

import { IOwner } from 'types/owner.types';

export const getColumnStatus = (column: string, count: number): "Due Soon" | "Overdue" | null => {
  if (count === 0) {
    return null;
  }

  const today = new Date();
  const day = today.getDate();

  if (column === "Inbox") {
    if (day >= 4 && day <= 7) {
      return "Due Soon";
    }
    if (day >= 8) {
      return "Overdue";
    }
  }

  if (column === "Performance Update Done") {
    if (day >= 26) {
      return "Due Soon";
    }
  }

  return null;
};

interface IEmailBlock {
  title: string;
  color: string;
  weekday: string;
  type: string
  handleOpenClientCommunicationDr: () => void
  handleCloseClientCommunicationDr: () => void
  isDrawerOpen: boolean
}

const EmailBlock:React.FC<IEmailBlock> = ({
  title,
  color,
  weekday,
  type,
  handleOpenClientCommunicationDr,
  handleCloseClientCommunicationDr,
  isDrawerOpen,
}) => {
  const styles = useStylesEmailBlock({
    color,
    weekday,
    title,
  });

  const {
    inboxData,
    flattenedArrayInboxResult,

    performanceUpdateDoneData,
    flattenedArrayPerformanceUpdateDoneResult,

    doneData,
    flattenedArrayDoneResult,
  } = useClientCommunicationContext();

  const [isEditModeOn, setIsEditModeOn] = useState<boolean>(false);
  const [emailId, setEmailId] = useState<number>();
  const [status, setStatus] = useState<string>("");
  const [currentElementIndex, setCurrentElementIndex] = useState<number >(0);

  let emailReportsData;
  let emailReportsModifiedData;

  switch (type) {
    case "done":
      emailReportsData = doneData;
      emailReportsModifiedData = flattenedArrayDoneResult;
      break;
    case "performance_update_done":
      emailReportsData = performanceUpdateDoneData;
      emailReportsModifiedData = flattenedArrayPerformanceUpdateDoneResult;
      break;
    default:
      emailReportsData = inboxData;
      emailReportsModifiedData = flattenedArrayInboxResult;
      break;
  }

  const emailReportsDataCount = emailReportsData?.pages[0].data.count;

  const handleBtnClick = (
    id: number,
    status: string,
    index: number,
  ) => {
    handleOpenClientCommunicationDr();
    setStatus(status);
    setEmailId(id);
    setCurrentElementIndex(index);
  };

  const handleCloseDrawer = () => {
    handleCloseClientCommunicationDr();
    setIsEditModeOn(false);
  };

  const columnStatus = getColumnStatus(title, emailReportsDataCount);

  return (
    <Flex className={styles.emailHeader} direction="column">
      <Flex style={{ width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} className={styles?.titleContainer}>
        <h4>
          {title} {emailReportsDataCount ? `(${emailReportsDataCount})` : "(0)"}
        </h4>
        {(title === "Performance Update Done" || title === "Inbox") && columnStatus && (
          <div className={clsx('tab-title-tag', {
            overdue: columnStatus === 'Overdue',
            due_soon: columnStatus === 'Due Soon',
          })}>
            <CustomIcon name={columnStatus === 'Overdue' ? 'hourglass_low' : 'clock'} sx={{ fontSize: 16, color: columnStatus === 'Overdue' ? '#9A004A' : '#B3261E' }} />
            <span className="tab-title-tag-content">{columnStatus}</span>
          </div>
        )}
      </Flex>
      <>
        {emailReportsModifiedData?.map((details: IOwner, index: number) => (
          <OwnerCard key={details.owner_id} index={index} ownerDetails={details} onClickReview={handleBtnClick} />
        ))}
      </>
      {emailId && (
        <UserEmailDrawer
          setEmailId={setEmailId}
          emailId={emailId}
          drawerOpen={isDrawerOpen}
          isEditModeOn={isEditModeOn}
          setIsEditModeOn={setIsEditModeOn}
          handleCloseDrawer={handleCloseDrawer}
          status={status}
          currentElementIndex={currentElementIndex}
          setCurrentElementIndex={setCurrentElementIndex}
          type={type}
        />
      )}
    </Flex>
  );
};

export default EmailBlock;
